import { InteractiveSection } from './InteractiveSection';
import { OpenAPIRootSchema } from './OpenAPISchemaServer';
import { t } from './translate';
import { checkIsReference, createStateKey } from './utils';
/**
 * Display an interactive request body.
 */
export function OpenAPIRequestBody(props) {
    var _a;
    var requestBody = props.requestBody, context = props.context, data = props.data;
    if (checkIsReference(requestBody)) {
        return null;
    }
    return (<InteractiveSection header={t(context.translation, 'name' in data ? 'payload' : 'body')} className="openapi-requestbody" stateKey={createStateKey('request-body-media-type', context.blockKey)} selectIcon={context.icons.chevronDown} tabs={Object.entries((_a = requestBody.content) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
            var _b;
            var contentType = _a[0], mediaTypeObject = _a[1];
            return {
                key: contentType,
                label: contentType,
                body: (<OpenAPIRootSchema schema={(_b = mediaTypeObject.schema) !== null && _b !== void 0 ? _b : {}} context={context}/>),
            };
        })}/>);
}
